import * as React from 'react';

import { NonEmptyArray, FOfferType } from 'shared/common/packages/JsonQuery';
import { EHouseMaterial } from 'shared/common/packages/api-models/common/json_query';

import { getConstructionTypesList } from './helpers';
import { CheckboxButtonGroupUnselectable } from '../../CheckboxButtonGroupUnselectable';
import { Filter } from '../common/Filter';

interface IConstructionTypeProps {
  offerType: FOfferType;
  value: NonEmptyArray<EHouseMaterial> | null;
  onChange(value: NonEmptyArray<EHouseMaterial> | null): void;
  label: string;
}

export const ConstructionType: React.FC<IConstructionTypeProps> = ({ offerType, value, onChange, label }) => {
  const constructionTypes = getConstructionTypesList(offerType);

  return (
    <Filter id="advancedFilter_constructionType" label={label}>
      <CheckboxButtonGroupUnselectable options={constructionTypes} value={value} onChange={onChange} />
    </Filter>
  );
};
